import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';

import Header from '../components/Header';
import LoginContainer from '../container/LoginContainer';
import RegisterContainer from '../container/RegisterContainer';
import Animation from '../components/Animation';
import { Typography, Grid, Hidden } from '@material-ui/core';
import ResetPasswordContainer from '../container/ResetPasswordContainer';
import * as routes from './../../infrastructure/routemap';
import { VSpacer } from 'sm-react-components';

const styles = {
    infoColumn: {
        flex: '0 0 300px'
    },
    contentColumn: {
        flex: 'auto',
        padding: '16px',
        width: 'min-content',
        height: '440px'
    }
};

class Login extends Component {
    constructor() {
        super();
        this.state = {
            email: '',
            password: '',
            error: undefined,
            ready: false,
            loading: false,
            success: false
        };
    }

  leftpanel = () => {
      return (
          <div style={{ position: 'relative', width: '300px', height: '440px' }}>
              <div
                  style={{
                      position: 'absolute',
                      backgroundColor: '#4C5D7F',
                      backgroundSize: 'cover'
                  }}
              >
                  <Animation animation={'map_orange_poi'} width={300} height={440} />
              </div>

              <div style={{ position: 'absolute', width: '300px' }}>
                  <Grid container spacing={16} style={{ padding: '16px' }}>
                      <Grid item>
                          <Typography
                              variant="h2"
                              style={{ color: 'white', marginTop: '15px' }}
                          >
                Flake
                          </Typography>
                      </Grid>
                      <Grid item>
                          <Typography variant="h4" style={{ color: 'white' }}>
                Optimize your routes
                          </Typography>
                      </Grid>
                      <Grid item>
                          <Typography variant="h5" style={{ color: 'white' }}>
                Get the most of SmartMonkey technology with our no-charge Flake
                Console.
                          </Typography>
                      </Grid>
                  </Grid>
              </div>
          </div>
      );
  };

  render() {
      const { classes, route, queryString, token } = this.props;
      return (
          <div>
              <Header help helpCallback={() => window.open(routes.extenal.docs)} />
              <VSpacer />
              <Grid container justify="center">
                  <Grid
                      item
                      xl={4}
                      lg={6}
                      md={8}
                      sm={11}
                      xs={12}
                      style={{ maxWidth: '700px' }}
                  >
                      <Grid container component={Card}>
                          <Hidden xsDown>
                              <Grid item className={classes.infoColumn}>
                                  {this.leftpanel()}
                              </Grid>
                          </Hidden>
                          <Grid item className={classes.contentColumn}>
                              {route === 'login' && (
                                  <LoginContainer validation={queryString.validation} />
                              )}
                              {route === 'register' && <RegisterContainer />}
                              {route === 'reset-password' && (
                                  <ResetPasswordContainer token={token} />
                              )}
                          </Grid>
                      </Grid>
                  </Grid>
              </Grid>
          </div>
      );
  }
}

export default withStyles(styles)(Login);
